/**
 * @generated SignedSource<<d42edfe39ae89f6b50fed7f75a99cf48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DashboardOfferItem_offer$data = {
  readonly id: string;
  readonly title: string;
  readonly imageUrl: string | null;
  readonly guid: string;
  readonly advertiser: {
    readonly name: string | null;
    readonly imageUrl: string | null;
  } | null;
  readonly tags: ReadonlyArray<string>;
  readonly paysReward: boolean;
  readonly rewardLabel: string | null;
  readonly " $fragmentType": "DashboardOfferItem_offer";
};
export type DashboardOfferItem_offer$key = {
  readonly " $data"?: DashboardOfferItem_offer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardOfferItem_offer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardOfferItem_offer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "guid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Advertiser",
      "kind": "LinkedField",
      "name": "advertiser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paysReward",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rewardLabel",
      "storageKey": null
    }
  ],
  "type": "Offer",
  "abstractKey": null
};
})();

(node as any).hash = "c8b20a36f63d55a9fac352a2532ce9c3";

export default node;
